export default "__VITE_ASSET__DjqK6XEK__"